import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';

const variantMap = {
    large: 'h1',
    medium: 'h2',
    small: 'h3',
    smallest: 'h4',
    subheading1: 'h5',
    subheading2: 'h6'
};
const Heading = (_param)=>{
    var { align ='inherit' , className , color ='inherit' , component , visualHeadingOnly =false , variant ='large' , 'data-t': testId = 'typography-heading'  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "align",
        "className",
        "color",
        "component",
        "visualHeadingOnly",
        "variant",
        'data-t'
    ]);
    const mappedVariant = variantMap[variant];
    const Component = component || mappedVariant;
    const hasAria = component === 'div' && !visualHeadingOnly;
    return /*#__PURE__*/ React.createElement(Component, swcHelpers.extends({}, hasAria && {
        role: 'heading',
        'aria-level': mappedVariant ? parseInt(mappedVariant.substring(1), 10) : 2
    }, {
        className: classnames('typography-heading', `typography-heading--${variant}`, className, {
            [`typography-heading--align-${align}`]: align !== 'inherit',
            [`typography-heading--color-${color}`]: color !== 'inherit'
        }),
        "data-t": testId
    }, rest));
};
var Heading$1 = Heading;

export { Heading$1 as default, variantMap };
//# sourceMappingURL=Heading.js.map
